import * as yup from "yup";

const phoneRegExp = /^(?:50|51|52|54|55|56|58|2|3|4|6|7|9)\d{7}$/;
const numbersRegExp = /^\d+$/;
const arabicEnglishRegExp = /^[a-zA-Z\u0600-\u06FF ]*$/;
const arabicEnglishNumbersRegExp = /^[a-zA-Z\u0600-\u06FF0-9 ]*$/;
const nationalIdRegex =
  /^([1-9]{1})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})[0-9]{3}([0-9]{1})[0-9]{1}$/;
const fileSchema = yup
  .mixed()
  .test(
    "fileSize",
    "يجب أن يكون أقل من 5 ميغابايت",
    (value) => !value || (value && value.size <= 5 * 1024 * 1024)
  )
  .test(
    "fileType",
    "نوع الملف غير صحيح. يرجى تحميل نوع الملف الصحيح",
    (value) =>
      !value ||
      (value && value.type === "application/pdf") ||
      value?.type.startsWith("image/")
  );

// Schema factory function
export const ArSchema = (selectedProduct) => {
  return yup.object().shape({
    name: yup
      .string()
      .min(3, "يجب ألا يقل عن 3 حروف")
      .trim()
      .matches(arabicEnglishRegExp, "غير صحيح")
      .required("إجباري"),
    mobilePhone: yup
      .string()
      .min(9, "يجب أن يكون 9 رقم")
      .max(9, "يجب أن يكون 9 رقم")
      .matches(
        phoneRegExp,
        "يجب أن يبدأ رقم الهاتف بـ (50/51/52/54/55/56/58) مباشرة"
      )
      .required("اجباري"),
    email: yup.string().email("غير صحيح").required("إجباري"),
    product: yup.string().required("إجباري"),
    // Conditionally required fields
    ...((selectedProduct === "auto" || selectedProduct === "trucks") && {
      category: yup.string().required("إجباري"),
      amount: yup
        .string()
        .matches(numbersRegExp, "غير صحيح")
        .required("إجباري"),
    }),
    ...(selectedProduct === "mortgage" && {
      mortgageType: yup.string().required("اجباري"),
    }),
    passportUrl: fileSchema.required("اجباري"),
    workPermitUrl: fileSchema.notRequired(),
    hrLetter: fileSchema.notRequired(),
    bankStatementUrl: fileSchema.notRequired(),
    EgyptAddress: yup.string().required("اجباري"),
    message: yup
      .string()
      .min(3, "يجب ألا يقل عن 3 حروف")
      .max(800, "يجب ألا يزيد عن 800 حرف")
      .trim(),
    preferredCallingTime: yup.string().required("اجباري"),
  });
};
